import type { Cents } from './money.js';

export type ItemId = string;
export type PersonId = string;

/**
 * Coarse semantic buckets. Not decoration — this is what lets "we split the
 * alcohol" resolve to a concrete set of items without the model having to
 * re-read the receipt.
 */
export const CATEGORIES = [
  'alcohol',
  'drink',
  'food',
  'meat',
  'dessert',
  'tobacco',
  'other',
] as const;
export type Category = (typeof CATEGORIES)[number];

export interface Item {
  id: ItemId;
  name: string;
  qty: number;
  unitPrice: Cents;
  lineTotal: Cents;
  category: Category;
  /** Set on a unit split out of a multi-quantity line; see split/units.ts. */
  unitOf?: { itemId: ItemId; index: number; count: number };
}

export interface Receipt {
  currency: string;
  merchant?: string;
  items: Item[];
  subtotal?: Cents;
  tax?: Cents;
  tip?: Cents;
  total?: Cents;
}

export interface Person {
  id: PersonId;
  name: string;
}
